import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CacheService } from 'app-service';
import { AuthInterceptor } from './auth-interceptor';
import { LoadingInterceptor } from './loading-interceptor';
import { ErrorInterceptor } from './error-interceptor';
import { CSRFInterceptor } from './csrf-interceptor';
import { NgswBypassInterceptor } from './service-worker.interceptor';

@NgModule({
	imports: [
		HttpClientModule,
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: LoadingInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: CSRFInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: NgswBypassInterceptor,
			multi: true
		},
		CacheService
	]
})
export class InterceptorsModule { }
